
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-los-implementer",
      function () {
        return require("private-next-pages/become-a-los-implementer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-los-implementer"])
      });
    }
  